module.exports = __webpack_public_path__ + "static/baixe-agora-app-5f0d04e218fd010ef3347949c14e465e.svg";